export const styles = {
  backdrop: {
    position: 'fixed',
    inset: 0,
    backgroundColor: 'rgba(17, 24, 39, 0.45)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 9999,
    padding: 16,
  },
  modal: {
    width: 'min(720px, 100%)',
    backgroundColor: '#FFFFFF',
    borderRadius: 14,
    border: '1px solid #E5E7EB',
    boxShadow: '0 24px 60px rgba(0,0,0,0.20)',
    padding: 18,
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 12,
  },
  headerTitle: { fontSize: 18, fontWeight: 700, color: '#111827' },
  closeBtn: {
    width: 34,
    height: 34,
    borderRadius: 10,
    border: '1px solid transparent',
    background: 'transparent',
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  topCard: {
    border: '1px solid #F3F4F6',
    backgroundColor: '#F9FAFB',
    borderRadius: 12,
    padding: 14,
  },
  topCardTitle: { fontSize: 14, fontWeight: 700, color: '#111827' },
  topCardSub: { marginTop: 4, fontSize: 12, color: '#6B7280' },
  divider: { height: 1, backgroundColor: '#E5E7EB', margin: '14px 0' },
  row: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 12,
    padding: '10px 2px',
  },
  rowLeft: { display: 'flex', alignItems: 'center', gap: 12, minWidth: 0 },
  rowIcon: {
    width: 34,
    height: 34,
    borderRadius: 10,
    backgroundColor: '#F3F4F6',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  rowTitle: { fontSize: 14, fontWeight: 700, color: '#111827' },
  rowSub: { marginTop: 2, fontSize: 12, color: '#6B7280' },

  switchWrap: { border: 0, background: 'transparent', padding: 0, cursor: 'pointer' },
  switchTrack: (on) => ({
    width: 44,
    height: 24,
    borderRadius: 999,
    backgroundColor: on ? '#0B2A4A' : '#E5E7EB',
    position: 'relative',
    display: 'inline-block',
  }),
  switchThumb: (on) => ({
    width: 20,
    height: 20,
    borderRadius: 999,
    backgroundColor: '#FFFFFF',
    position: 'absolute',
    top: 2,
    left: on ? 22 : 2,
    transition: 'left 160ms ease',
  }),

  daysPill: {
    fontSize: 12,
    fontWeight: 700,
    color: '#111827',
    backgroundColor: '#F3F4F6',
    borderRadius: 999,
    padding: '6px 10px',
    flexShrink: 0,
  },

  sliderWrap: { marginTop: 6, paddingLeft: 46 },
  slider: { width: '100%', accentColor: '#0B2A4A' },
  sliderLabels: { display: 'flex', justifyContent: 'space-between', marginTop: 6 },
  sliderLabel: { fontSize: 12, color: '#6B7280' },

  warnBox: {
    marginTop: 16,
    padding: 12,
    borderRadius: 8,
    background: '#FFFBEB',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
    textAlign: 'center',
  },
  warnText: {
    fontSize: 13,
    color: '#92400E',
    fontWeight: 500,
    lineHeight: 1.4,
    textAlign: 'center',
    maxWidth: 420,
  },

  footer: { marginTop: 16, display: 'flex', justifyContent: 'flex-end', gap: 12 },
  cancelBtn: {
    height: 40,
    padding: '0 14px',
    borderRadius: 10,
    border: '1px solid #E5E7EB',
    backgroundColor: '#FFFFFF',
    color: '#111827',
    fontWeight: 700,
    cursor: 'pointer',
  },
  saveBtn: {
    height: 40,
    padding: '0 14px',
    borderRadius: 10,
    border: '1px solid #0B2A4A',
    backgroundColor: '#0B2A4A',
    color: '#FFFFFF',
    fontWeight: 800,
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    gap: 8,
  },
};
